import React from 'react';
import Slider from '../Slider';

const SlideChargerCount = ({value, onChange, maxChargers, label = '# of Chargers'}) => (
  <Slider label={label} min={1} max={maxChargers} value={value} onChange={onChange} />
);

export default SlideChargerCount;
